import { useContext } from "react";
import ThemeContext from "../../context/ThemeContext";
import styles from "./menus/NavMenu.module.css";

const NavbarOptionTheme = ({ closeMenus }) => {
  const themeCtx = useContext(ThemeContext);

  const changeThemeHandler = () => {
    themeCtx.toggleTheme();
    closeMenus();
  };

  return (
    <li>
      <button className={styles.menuOptionButton} onClick={changeThemeHandler}>
        <img
          alt={"theme toggle"}
          className={styles.themeSVG}
          src={themeCtx.icon}
        />
      </button>
    </li>
  );
};

export default NavbarOptionTheme;
